/**
 * @deprecated use `core/utils/date`
 */
export enum DateFormats {
  Time = 'h:mm aa',
  Day = 'EEE',
  Date = 'd MMM',
  DateO = 'do MMM',
  DateReverse = 'MMM d',
  FullDate = 'd MMM yyyy',
  MonthFullDate = 'MMM d, yyyy',
  DayAndTime = 'EEE, h:mm aa',
  DayAndDate = 'EEE, d MMM',
  DayAndFullDate = 'EEE, d MMM yyyy',
  DateAndTime = 'd MMM, h:mm aa',
  MonthDateAndTime = 'MMM d, h:mm aa',
  FullDateAndTime = 'd MMM yyyy, h:mm aa',
  DayDateAndTime = 'EEE, d MMM, h:mm aa',
  DayFullDateAndTime = 'EEE, d MMM yyyy, h:mm aa',
  DayFullDateAndTimeWithAt = `MMM d, yyyy 'at' h:mm a`,
}
